import { axiosInstance } from '../shared/services/axios-instance'
import * as endpoints from '../constants/activity-endpoints'

class ForumServices {
  static saveForumReply(id, commentContent, config) {
    const data = {
      comment: commentContent,
      forumId: id,
    }
    return axiosInstance
      .post(endpoints.replyForum, data, config)
      .then(resp => resp.data)
  }

  static getRepliesByForum(id, page, size, config) {
    return axiosInstance
      .get(
        endpoints.getRepliesByForum +
          `?forumId=${id}&page=${page}&size=${size}`,
        config
      )
      .then(resp => resp.data)
  }
  
  static getForumByConcourseId(id) {
    return axiosInstance
      .get(endpoints.getForumsByConcourse + `?concourseId=${id}`)
      .then(resp => resp.data)
  }

  static getLikeByCommentId(id, config) {
    return axiosInstance
      .get(endpoints.getLikeByCommentId + `?comentarioId=${id}`, config)
      .then(resp => resp.data)
  }

  static saveLikeByCommentId(id, like, config) {
    return axiosInstance
      .post(
        endpoints.saveLikeByCommentId + `?comentarioId=${id}&isLike=${like}`,
        {},
        config
      )
      .then(resp => resp.data)
  }

  static getReferralsByUser(config) {
    return axiosInstance
      .get(endpoints.getReferralsByUser, config)
      .then(resp => resp.data)
  }
}

export default ForumServices
